/**
 * Estado mínimo da legenda: recolhida ou aberta (lembrado no navegador) e as
 * escolhas feitas nesta sessão (bloco aberto por camada, chave de dia/noite).
 */
import { create } from 'zustand';
import type { Daypart } from './catalog';

const STORAGE_KEY = 'amaview:legenda-recolhida';

function readCollapsed(): boolean {
  try {
    return globalThis.localStorage?.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function writeCollapsed(collapsed: boolean): void {
  try {
    if (collapsed) globalThis.localStorage?.setItem(STORAGE_KEY, '1');
    else globalThis.localStorage?.removeItem(STORAGE_KEY);
  } catch {
    // navegação privada / armazenamento bloqueado: só não lembra
  }
}

interface LegendState {
  /** Painel inteiro recolhido (vira um botão "Legenda"). */
  collapsed: boolean;
  /** Bloco de cada camada aberto/fechado (por uid), quando o usuário mexeu. */
  open: Record<string, boolean>;
  /** Chave de dia/noite escolhida à mão (por uid + produto). */
  daypart: Record<string, Daypart>;
  setCollapsed: (collapsed: boolean) => void;
  setOpen: (uid: string, open: boolean) => void;
  setDaypart: (key: string, daypart: Daypart) => void;
}

export const useLegendStore = create<LegendState>()((set) => ({
  collapsed: readCollapsed(),
  open: {},
  daypart: {},
  setCollapsed: (collapsed) => {
    writeCollapsed(collapsed);
    set({ collapsed });
  },
  setOpen: (uid, open) => set((s) => ({ open: { ...s.open, [uid]: open } })),
  setDaypart: (key, daypart) => set((s) => ({ daypart: { ...s.daypart, [key]: daypart } })),
}));
